import React, { Component } from 'react';
import { Grid, Row, Col, Button } from 'react-bootstrap';
import Card from 'components/Card/Card.jsx';
import Form from 'react-jsonschema-form';

//Redux
import widgets from '../../lib/widgets';
import fields from '../../lib/fields';
import auth from '../../libCustom/auth';
import axios from 'axios';

const schema = {
  $id: 'http://example.com/example.json',
  type: 'object',
  definitions: {},
  $schema: 'http://json-schema.org/draft-07/schema#',
  properties: {
    firstName: {
      $id: '/properties/firstName',
      type: 'string',
      title: 'Nombre(s)',
      default: '',
      examples: ['Ana'],
    },
    lastName: {
      $id: '/properties/lastName',
      type: 'string',
      title: 'Apellidos',
      default: '',
      examples: ['Guerrero Lara'],
    },
    email: {
      $id: '/properties/email',
      type: 'string',
      title: 'Email',
      default: '',
      examples: ['example@gmail.com'],
    },
    password: {
      $id: '/properties/password',
      type: 'string',
      title: 'Contraseña',
      default: '',
      examples: ['example'],
    },
    phone: {
      $id: '/properties/phone',
      type: 'string',
      title: 'Teléfono',
      default: '',
      examples: ['443 45 43 45'],
    },
    emailConfiguration: {
      $id: '/properties/email',
      type: 'object',
      title: 'Configuración del correo',
      properties: {
        email: {
          $id: '/properties/email',
          type: 'string',
          title: 'Email para enviar correos',
          default: '',
          examples: ['example@gmail.com'],
        },
        password: {
          $id: '/properties/password',
          type: 'string',
          title: 'Contraseña del email para enviar correos',
          default: '',
          examples: ['example'],
        },
      },
    },
  },
};

const uiSchema = {
  email: {
    'ui:widget': 'email',
  },
  password: {
    'ui:widget': 'password',
  },
  emailConfiguration: {
    password: {
      'ui:widget': 'password',
    },
  },
};

const log = (type) => console.log.bind(console, type);
class Profile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formData: auth.getCurrentUser(),
      sendEmailText: 'ENVIAR EMAIL',
      sendingEmail: false,
      sendingButton: 'primary',
    };
  }

  componentWillMount() {}

  logout = () => {
    auth.logout();
  };

  onSubmit = ({ formData }) => {
    let newUserPost = {};
    if (
      formData.password === '' ||
      formData.password === undefined ||
      formData.password === null
    ) {
      newUserPost = {
        id: formData.id,
        firstName: formData.firstName,
        lastName: formData.lastName,
        email: formData.email,
        phone: formData.phone,
        emailConfiguration: {
          email: formData.emailConfiguration.email,
          password: formData.emailConfiguration.password,
        },
      };
    } else {
      newUserPost = {
        id: formData.id,
        firstName: formData.firstName,
        lastName: formData.lastName,
        email: formData.email,
        password: formData.password,
        phone: formData.phone,
        emailConfiguration: {
          email: formData.emailConfiguration.email,
          password: formData.emailConfiguration.password,
        },
      };
    }

    axios
      .patch(
        process.env.REACT_APP_URL_API + '/api/users/' + formData.id,
        newUserPost
      )
      .then(this.logout);
  };

  render() {
    const { formData } = this.state;
    return (
      <div className="main-content">
        <Grid fluid>
          <Row>
            <Col md={12}>
              <Card
                title={<legend>Editar mi perfil</legend>}
                content={
                  <div>
                    <Form
                      schema={schema}
                      fields={fields}
                      widgets={widgets}
                      uiSchema={uiSchema}
                      onSubmit={this.onSubmit}
                      onBlur={this.onBlur}
                      formData={formData}
                      onError={log('errors')}
                    >
                      <div>
                        <Button
                          bsStyle="success"
                          type="submit"
                          className="btn-fill"
                        >
                          Guardar
                        </Button>{' '}
                      </div>
                    </Form>

                    <div className="clearfix" />
                  </div>
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default Profile;



// WEBPACK FOOTER //
// ./src/views/Profile/ProfileForm.jsx